<template>
	<div>
		<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height" @show="modal_onshow" show-footer @hide="modal_onhide"
			destroy-on-close>
			<template #default>
				<vxe-grid v-if="list_gridOptions" v-bind="list_gridOptions" @toolbar-button-click="list_toolbarButtonClickEvent"></vxe-grid>
			</template>
			<template #footer>
				<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
				<vxe-button status="primary" content="确认" @click="submit"></vxe-button>
			</template>
		</vxe-modal>
	</div>
</template>
<style scoped>

</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	export default {
		mixins: [listMixins,modalMixins],
		props: {
			data: {
				default: () => {
					return []
				}
			}
		},
		
		data() {
			return {
				modal_title: '待开详情',
				modal_width:1000,
				modal_height:600,
				modal_model:false,
				list_formConfig: [{
						field: 'a',
						title: 'A',
						itemRender: {
							name: '$input'
						}
					}
				],
				list_columns: [
					{
						type: 'seq',
						title: '#',
						width:50,
						fixed:'left'
					},
					{
						field: 'code',
						title: '单据编码',
						width:200
					},
					{
						field: 'invoiceType',
						title: '票种',
						width:50,
						slots:{
							default({row}){
								return row.invoiceType == '01'?'专票':'普票'
							}
						}
					},
					{
						field: 'xsfMc',
						title: '销方名称',
						width:100
					},
					{
						field: 'xsfNsrsbh',
						title: '销方税号',
						width:120
					},
					{
						field: 'gmfMc',
						title: '购方名称',
						width:100
					},
					{
						field: 'gmfNsrsbh',
						title: '购方税号',
						width:120
					},
					{
						field: 'name',
						title: '商品名称',
						width:120
					},
					{
						field: 'sphfwssflhbbm',
						title: '商品和服务税收分类编码',
						width:200
					},
					{
						field: 'taxRate',
						title: '税率',
						width:100,
						fixed:'right'
					},
					{
						field: 'tax',
						title: '税额',
						width:100,
						fixed:'right'
					},
					{
						field: 'amount',
						title: '价税合计',
						width:100,
						fixed:'right'
					},
					{
						field: 'preInvoiceAmount',
						title: '预开票金额',
						width:100,
						fixed:'right'
					},
					{
						field: 'receivedAmount',
						title: '收款金额',
						width:100,
						fixed:'right'
					},
					{
						field: 'bz',
						title: '备注',
						width:100
					},
					{
						field: 'kprq',
						title: '手机号',
						width:100
					},
					{
						field: 'kprq',
						title: '邮箱',
						width:100
					},
					// {
					// 	title: '操作',
					// 	fixed: "right",
					// 	align: 'center',
					// 	width: 65,
					// 	slots: {
					// 		default: ({row}) => {
					// 			return [<el-button type = "text" size = "mini" onClick = {() => {this.ddcode(row)}}>凭证</el-button>]
					// 		}
					// 	}
					// }					
				],
				list_footerField:[
					{field:'amount',toFixed:2},
				]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {
			
		},
		methods: {
			list_beforeCreateGrid(gridOptions){
				gridOptions.formConfig = false
			},
			list() {
				return new Promise((resolve) => {
					let ids = this.data.map((item)=>{
						return item.id
					})
					this.$api.universalinvoice.getuploaddetail({
						ids:ids,
						type:'blue',
					}).then((res)=>{						
						resolve({
							list: res
						})
					},()=>{
						resolve({
							list: []
						})
					})
				})
			},
			submit() {
				this.$emit('submit',{data:this.data})
				this.modal_cancel()
				//this.init()
			},
			reset() {
				//this.init()
			}
		},
		components: {
			
		}
	}
</script>